export const TIME_DAY = 86400
export const TIME_HOUR = 3600

export const WEEKDAY_SHORT = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
export const WEEKDAY_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const WEEKDAY_KOREAN_LONG = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']

export const DEFERRED_MILLISEC = 300
